import React from 'react';
import classNames from 'classnames';

import {Badge, Text} from '@albert-io/atomic';

interface UsernameSuggestionsProps {
  suggestions: string[];
  selectedUsername: string;
  onSelect: (next: string) => void;
}

export default function UsernameSuggestions({
  suggestions,
  selectedUsername,
  onSelect
}: UsernameSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className='mt-x1 flex flex-wrap items-center gap-x1'>
      <Text>Suggested:</Text>
      {suggestions.map((s) => {
        const isSelected = selectedUsername === s;
        return (
          <Badge
            key={s}
            status='info'
            emphasis='subtle'
            roundness='pill'
            onClick={() => onSelect(s)}
            className={classNames('cursor-pointer', {
              'border border-info': isSelected
            })}
          >
            {s}
          </Badge>
        );
      })}
    </div>
  );
}
